import { useState, useEffect } from 'react';

export type Theme = 'light' | 'dark';

export const useTheme = () => {
  const [theme] = useState<Theme>('light');

  useEffect(() => {
    // Forzar siempre tema claro y eliminar clase dark si existe
    document.documentElement.classList.remove('dark');
    localStorage.removeItem('theme');
  }, []);

  // No-op para no romper componentes que llaman toggleTheme/setTheme
  const toggleTheme = () => {};
  const setTheme = () => {};

  return {
    theme,
    toggleTheme,
    setTheme,
  };
};
